export const cardSystems = {
    monetico: {
        name: 'Monetico'
    },
    scellius: {
        name: 'Scellius'
    },
    systempay: {
        name: 'Systempay'
    },
    sogecommerce: {
        name: 'Sogecommerce'
    }
}